module.exports = __webpack_public_path__ + "static/media/carousel-compromissos.64883db1.png";